import { Quaternion } from "three";
class EnemyInputController {
    rotation;
    /**
     * An input controller for enemy entities.
     * @param initialRotation The initial rotation of the entity. Defaults to an empty quaternion.
     */
    constructor(initialRotation = new Quaternion()) {
        this.rotation = initialRotation;
    }
    getFORWARD = false;
    getBACK = false;
    getLEFT = false;
    getRIGHT = false;
    getRUNNING = false;
    getJUMPING = false;
    getSHOOTING = false;
    getAIMING = false;
    get getRotation() {
        return this.rotation;
    }
}
export { EnemyInputController };
